<template>
  <div>
    <!-- Default Layout -->
    <a-layout class="layout-default" id="layout-default" :class="layoutClass">
      <!-- Layout Header (Navbar) -->
      <DefaultHeader />
      <!-- / Layout Header (Navbar) -->

      <!-- Page Content -->
      <a-layout-content class="content">
        <router-view />
      </a-layout-content>
      <!-- / Page Content -->

      <!-- Layout Footer -->
      <DefaultFooter />
      <!-- / Layout Footer -->
    </a-layout>
    <!-- / Default Layout -->
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DefaultHeader from '@/components/Headers/DefaultHeader.vue'
import DefaultFooter from '@/components/Footers/DefaultFooter.vue'

export default {
  name: 'DefaultLayout',
  components: {
    DefaultHeader,
    DefaultFooter,
  },
  setup() {
    const route = useRoute()
    
    const layoutClass = computed(() => {
      return route.meta.layoutClass || ''
    })
    
    return {
      layoutClass
    }
  }
}
</script>

<style scoped>
.layout-default {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  padding: 50px;
  background: #f0f2f5;
}

@media (max-width: 768px) {
  .content {
    padding: 20px;
  }
}
</style>